import CodeComponent from '@/release-notes/CodeComponent.vue';
import LinkComponent from '@/release-notes/LinkComponent.vue';

export const portableTextMarks = {
  link: LinkComponent,
  code: CodeComponent,
};
